import type { InventoryUnit } from "@common/types/Inventory";

const resolveInventoryUnit = (unit: InventoryUnit) => unit.abbreviation ?? unit.label;

export default resolveInventoryUnit;
